import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoneyCircle12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoneyCircle12Filled"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#MoneyCircle12Filled)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m.5-9.771a.5.5 0 0 0-1 0v.282c-.425.053-.792.176-1.077.403-.437.35-.576.855-.576 1.379 0 .64.33 1.082.74 1.388.384.285.876.481 1.291.646l.008.004c.45.179.817.326 1.08.514.24.17.33.328.33.534 0 .33-.16.573-.429.755-.283.19-.667.292-1.01.292-.469 0-.773-.165-.96-.318a1.3 1.3 0 0 1-.248-.272l-.006-.01a.5.5 0 0 0-.88.474l.441-.234-.442.234.001.002.001.002.004.006.008.015a1.3 1.3 0 0 0 .12.178c.08.106.202.243.37.38.28.23.688.451 1.234.52v.368a.5.5 0 1 0 1 0v-.418c.322-.072.644-.2.926-.39.487-.328.87-.857.87-1.584 0-.63-.342-1.058-.749-1.348-.366-.262-.835-.448-1.236-.608l-.055-.021c-.445-.178-.81-.329-1.072-.523-.236-.176-.337-.35-.337-.586 0-.356.09-.509.2-.597.14-.112.433-.219 1.038-.219.517 0 .835.173 1.02.324a1.2 1.2 0 0 1 .24.268l.005.009a.5.5 0 0 0 .895-.446l-.442.216.442-.217-.001-.002-.001-.002-.004-.006-.008-.016-.026-.047a2.2 2.2 0 0 0-.467-.531A2.45 2.45 0 0 0 6.5 2.505zM4.643 7.826"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="MoneyCircle12Filled">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconMoneyCircle12Filled);
